// extracted by mini-css-extract-plugin
export default {"kycBanner":"Xiu8sE","imageBanner":"OeRNzV","kycBannerContent":"r_sbl9","kycBannerTitle":"KWzd8x","kycBannerDesc":"RhLM7R","kycBannerImage":"j1v39V","imageBannerImage":"HntLUz"};